import React from 'react'
import PropTypes from 'prop-types'

import SimpleHeader from './../block/SimpleHeader'

import { AdresMap, Routing, Phone, Mail } from './../block/Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { data, user, assets_path } = this.props

    return (
      <div
        className='bg-cover bg-center bg-no-repeat pb-[50px]'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container leading-none'>
          <SimpleHeader
            title={`Контакты`}
            user={user}
            lk_link={data?.lk_link}
          />
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[8px] text-center'>
            <div className='text-[18px] font-medium text-black flex items-center justify-center gap-[7px]'>
              Адрес
              <AdresMap />
            </div>
            <div className='text-[14px] font-normal text-[#00000099] mt-[5px]'>
              г. Пущино, улица Строителей, 2Д
            </div>
            <a 
              href="https://yandex.ru/maps/217/pushino/?ll=37.631505%2C54.833490&mode=routes&rtext=~54.833490%2C37.631505&rtt=auto&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fdata%3DCgoyMTE5NjAxODkxEpUB0KDQvtGB0YHQuNGPLCDQnNC-0YHQutC-0LLRgdC60LDRjyDQvtCx0LvQsNGB0YLRjCwg0LPQvtGA0L7QtNGB0LrQvtC5INC-0LrRgNGD0LMg0KHQtdGA0L_Rg9GF0L7Qsiwg0J_Rg9GJ0LjQvdC-LCDRg9C70LjRhtCwINCh0YLRgNC-0LjRgtC10LvQtdC5LCAy0JQiCg2qhhZCFX5VW0I%2C&source=serp_navig&z=17"
              target='_blank'
              className="flex flex-1 items-center gap-[9px] h-[50px] p-[5px] rounded-full cursor-pointer bg-[#5A91FF] bluebtn-shadow w-[100%] mt-[10px]"
            >
              <div className='flex flex-none items-center justify-center w-[40px] h-[40px] rounded-full bg-[#FFFFFF40]'>
                <Routing />
              </div>
              <div className='text-[16px] flex flex-1 items-center justify-around gap-[5px] me-[12px] text-nowrap tracking-tight text-white'>
                <div className='flex items-center gap-[8px]'>
                  <div>Построить маршрут</div>
                </div>
              </div>
            </a>
            <a href="https://yandex.ru/maps/?um=constructor%3A2eeda33f0b50b35d38b003cb436f1702d436aeb1ea374a7c17bcf039a9c3744d&source=constructorStatic" target="_blank">
              <img src="https://api-maps.yandex.ru/services/constructor/1.0/static/?um=constructor%3A2eeda33f0b50b35d38b003cb436f1702d436aeb1ea374a7c17bcf039a9c3744d&width=500&height=400&lang=ru_RU" alt="На карте" className='w-full h-auto rounded-[25px] mt-[10px]' />
            </a>
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[5px] text-center'>
            <div className='text-[18px] font-medium text-black mb-[8px] flex items-center justify-center gap-[7px]'>
              Номера телефонов
              <Phone />
            </div>
            <div className='text-[14px] font-normal text-[#00000099]'>
              8 (495) 845-12-55
            </div>
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[5px] text-center'>
            <div className='text-[18px] font-medium text-black mb-[8px] flex items-center justify-center gap-[7px]'>
              Электронная почта
              <Mail />
            </div>
            <div className='text-[14px] font-normal text-[#00000099]'>
              rybkasverhy@mail.ru
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  user: PropTypes.object,
  assets_path: PropTypes.string
}

export default Main